import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

const ReactstrapFormikAmountInput = ({ field: { ...fields }, form: { touched, errors }, ...props }) => {
    const { id, ...rest } = props;
    return (
        <Form.Group controlId={id} className="form-group">
            {props.label && <Form.Label className={'label-color'}>{props.label}</Form.Label>}
            <InputGroup>
                <div className="input-group-prepend">
                    <InputGroup.Text>{props.prefixlabel}</InputGroup.Text>
                </div>
                <Form.Control
                    {...rest}
                    {...fields}
                    isInvalid={Boolean(touched[fields.name] && errors[fields.name])}
                    onChange={(value) => props.onChange(value)}
                    onBlur={() => props.onBlur && props.onBlur()}
                    step={0.01}
                />
            </InputGroup>
            {touched[fields.name] && errors[fields.name] && errors[fields.name] !== 'required' && (
                <Form.Control.Feedback className="pb-0 error invalid-feedback d-block" type="invalid">
                    {errors[fields.name]}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    );
};
export default ReactstrapFormikAmountInput;
